import { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import DashboardLayout from "reusableComponents/LayoutContainers/DashboardLayout";
import ProfileInfoCard from "reusableComponents/Cards/InfoCards/ProfileInfoCard";
import Header from "layouts/profile/components/Header";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { updateProfile, getProfile } from "../../axios-client";
import Footer from "../../reusableComponents/Footer";
import DashboardNavbar from "../../reusableComponents/Navbars/DashboardNavbar";
import {useSoftUIController} from "../../context";
import { useTranslation } from "react-i18next";

function Profile() {

    const [controller, dispatch] = useSoftUIController();
    const {role} = controller;
    const { t } = useTranslation('profile');

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        address: "",
        departments: "",
        university: "",
        profile_picture:""
    });
    const [errors, setErrors] = useState({});
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "" });
    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = t("profile.errors.nameRequired");

        const phonePattern = /^\+?[1-9]\d{1,14}$/;
        if (!formData.phone || !phonePattern.test(formData.phone)) newErrors.phone = t("profile.errors.invalidPhone");
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {

            const formDataToSend = new FormData();
            formDataToSend.append('name', formData.name);
            formDataToSend.append('phone', formData.phone);
            formDataToSend.append('address', formData.address);


            if (formData.profile_picture) {
                formDataToSend.append('profile_picture', formData.profile_picture);
            }

            try {
                const response = await updateProfile(formData.id, formDataToSend, role);
                setSnackbar({ open: true, message: t("profile.errors.updateSuccess"), severity: "success" });
                window.location.reload();
            } catch (error) {
                setSnackbar({ open: true, message: t("profile.errors.updateError"), severity: "error" });
            }
        }
    };

    const handleSnackbarClose = () => {
        setSnackbar({ open: false, message: "", severity: "" });
    };

    useEffect(() => {
        async function fetchUserProfile() {
            try {
                const response = await getProfile(role);
                if (response && response.data) {
                    const {name, phone, email, address, departments, university, profile_picture} = response.data;
                    setFormData({
                        name: name,
                        phone: phone,
                        email: email,
                        address: address,
                        departments: departments,
                        profile_picture: profile_picture,
                        university: university,
                        id: response.data.id,
                    });
                }
            } catch (error) {
                console.error("Failed to fetch user profile", error);
            }
        }

        if (role) {
            fetchUserProfile();
        }
    }, [role]);

    return (
        <DashboardLayout>
            <DashboardNavbar/>
            <Header info={formData}
                    setInfo={setFormData}/>
            <SoftBox mt={5} mb={3}>
                        <ProfileInfoCard
                            title={t("profile.title")}
                            info={formData}
                            setInfo={setFormData}
                            errors={errors}
                            handleSubmit={handleSubmit}
                            action={{ route: "", tooltip: t("profile.tooltip.edit")}}
                        />
            </SoftBox>

            <Footer />

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </DashboardLayout>
    );
}

export default Profile;
